<template>
  <div class="container-fluid">
    <div class="row">
      <div v-for="step in steps" class="col-md">
        <div class="step translucent-border">
          <div class="container-fluid">
            <div class="row no-gutters">
              <div class="col-4 col-lg-3">
                <div class="num-dot rounded-circle">{{ step.num }}</div>
              </div>
              <div class="col-8 col-lg-9">
                <span v-html="step.text"></span>
              </div>
            </div>
          </div>
        </div>
        <br />
      </div>
    </div>
  </div>
</template>


<script>
  import { mapState, mapActions } from 'vuex'
  import OperationList from './OperationList'
  import productService from '../api/productService'
  import calculationService from "../api/calculationService"

  export default {
    name: 'InfoSteps',
    props: [
      'step1',
      'step2',
      'step3'
    ],

    computed: {
      steps() {
        return [
          {
            num: 1,
            text: this.step1
          },{
            num: 2,
            text: this.step2
          },{
            num: 3,
            text: this.step3
          }
        ];
      }
    }
  }
</script>

<style scoped>
  .num-dot-wrap {
    text-align: center;
    padding-bottom: 10px;
  }
  .num-dot {
    display: inline-block;
    background-color: #c31a2f;
    color: white;
    width: 50px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    vertical-align: middle;
    font-weight: bold;
    font-size: 1.5em;
  }

  .step {
    padding-top: 20px;
    padding-bottom: 20px;
    background-color: #dbcfc1;
    font-size: 1.2em;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/InfoSteps.vue